"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionGroupFilter = exports.TransactionDescription = exports.TransactionType = void 0;
var TransactionType;
(function (TransactionType) {
    TransactionType["payment"] = "PMT";
    TransactionType["INV"] = "INV";
    TransactionType["credit"] = "CRE";
    TransactionType["debit"] = "DEB";
    TransactionType["service_Fee"] = "SVC";
    TransactionType["discontinued_when_out"] = "DWO";
    TransactionType["INVOICE"] = "INVOICE";
    TransactionType["PREDELIVERY_INVOICE"] = "PREDELIVERY_INV";
    TransactionType["INVOICE_WILL_CALL"] = "FWC_INV";
    TransactionType["INVOICE_VENDOR_SHIP"] = "VEND_SHIP";
    TransactionType["INVOICE_CHEF_STORE"] = "CASH_CARRY";
    TransactionType["CREDIT_MEMO"] = "CREDIT_MEMO";
    TransactionType["CREDIT_MEMO_SUMMARY"] = "CREDIT_MEMO_SUMMARY";
    TransactionType["CRE_SHORT"] = "CR";
    TransactionType["DEBIT_MEMO"] = "DEBIT_MEMO";
    TransactionType["DEBIT_MEMO_SUMMARY"] = "DEBIT_MEMO_SUMMARY";
    TransactionType["DEB_SHORT"] = "DB";
    TransactionType["DFT"] = "DFT";
    TransactionType["DWR"] = "DWR";
    TransactionType["MSC"] = "MSC";
    TransactionType["NRC"] = "NRC";
    TransactionType["PLN"] = "PLN";
    TransactionType["PMD"] = "PMD";
    TransactionType["RCF"] = "RCF";
    TransactionType["SAL"] = "SAL";
    TransactionType["UPY"] = "UPY";
    TransactionType["NSE"] = "NSE";
    TransactionType["NSF"] = "NSF";
    TransactionType["RTK"] = "RTK";
    TransactionType["OTHER"] = "OTHER";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var TransactionDescription;
(function (TransactionDescription) {
    TransactionDescription["INVOICE"] = "Invoice";
    TransactionDescription["CREDIT_MEMO"] = "Credit";
    TransactionDescription["PREDELIVERY_INV"] = "Delivery Invoice";
    TransactionDescription["FWC_INV"] = "Will Call Invoice";
    TransactionDescription["DEBIT_MEMO"] = "Debit";
    TransactionDescription["CASH_CARRY"] = "Chef Store";
    TransactionDescription["VEND_SHIP"] = "Vendor Ship";
    TransactionDescription["CREDIT_MEMO_SUMMARY"] = "Credit";
    TransactionDescription["DEBIT_MEMO_SUMMARY"] = "Debit";
    TransactionDescription["CR"] = "Credit";
    TransactionDescription["CRE"] = "Credit";
    TransactionDescription["DB"] = "Debit";
    TransactionDescription["DEB"] = "Debit";
    TransactionDescription["DFT"] = "Draft/Refund";
    TransactionDescription["DWR"] = "Adj Reversal";
    TransactionDescription["INV"] = "Invoice";
    TransactionDescription["MSC"] = "Misc AR";
    TransactionDescription["NRC"] = "Notes Receivable";
    TransactionDescription["PLN"] = "Payment Plan";
    TransactionDescription["PMD"] = "Payment Discrepancy";
    TransactionDescription["RCF"] = "Return Check Fee";
    TransactionDescription["SAL"] = "Sales Adj";
    TransactionDescription["SVC"] = "Service Charge";
    TransactionDescription["UPY"] = "Unapplied Payment";
    TransactionDescription["NSE"] = "NSF 2X EFT Process";
    TransactionDescription["NSF"] = "Non Sufficient Funds";
    TransactionDescription["RTK"] = "Cash";
})(TransactionDescription = exports.TransactionDescription || (exports.TransactionDescription = {}));
var TransactionGroupFilter;
(function (TransactionGroupFilter) {
    TransactionGroupFilter["INVOICE"] = "INVOICE,INV,PREDELIVERY_INV";
    TransactionGroupFilter["INVOICE_WILL_CALL"] = "FWC_INV";
    TransactionGroupFilter["INVOICE_VENDOR_SHIP"] = "VEND_SHIP";
    TransactionGroupFilter["INVOICE_CHEF_STORE"] = "CASH_CARRY";
    TransactionGroupFilter["INVOICE_ALL"] = "INVOICE,INV,PREDELIVERY_INV,FWC_INV,VEND_SHIP,CASH_CARRY";
    TransactionGroupFilter["CREDIT"] = "CREDIT_MEMO,CREDIT_MEMO_SUMMARY,CR,CRE";
    TransactionGroupFilter["DEBIT"] = "DEBIT_MEMO,DEBIT_MEMO_SUMMARY,DB,DEB";
    TransactionGroupFilter["STANDARD_ALL"] = "INVOICE,INV,PREDELIVERY_INV,FWC_INV,VEND_SHIP,CASH_CARRY,CREDIT_MEMO,CREDIT_MEMO_SUMMARY,CR,CRE,DEBIT_MEMO,DEBIT_MEMO_SUMMARY,DB,DEB";
    TransactionGroupFilter["OTHER"] = "OTHER";
})(TransactionGroupFilter = exports.TransactionGroupFilter || (exports.TransactionGroupFilter = {}));
